/* Copyright Information: Created by BuyGroup */
import React, { useEffect, useState, useRef } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Container,
  CardHeader,
  FormGroup,
  Label,
  Input,
  Form,
  Spinner,
} from "reactstrap";
import Select from "react-select";
import SunEditor from "suneditor-react";
import list from "suneditor/src/plugins/submenu/list";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import trimObj from "../components/common/TrimData";
import plugins from "suneditor/src/plugins";
import "suneditor/dist/css/suneditor.min.css";
import AddSupplier from "../Suppliers/AddSupplier";
import {
  createProduct,
  supplierList,
  categoryList,
  getSubCategoryDetail,
  fetchAmazonProductByASIN,
} from "../services/ProductServices";
import { addNewSupplier } from "../services/SupplierServices";
import { Link, useHistory } from "react-router-dom";
import Breadcrumbs from "../components/common/breadcrumb";
import { Formik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import "./Product.css";
import {
  createAmazonSpecificationHtml,
  sanitizeProductSpecification,
} from "../utils/sanitizeHtml";
toast.configure();

const addProductDefaultValues = {
  images: [],
  product_name: "",
  upc: "",
  unit: "",
  weight: "",
  manufacturer: "",
  description: "",
  category: "",
  sub_category: "",
  suppliers: [],
  specification: "",
  price: "",
  upload_doc: [],
  expiration_date: null,
  lot_size: "",
  minimum_quantity: "",
  maximum_quantity: "",
  is_taxable: false,
  tax_rate: null,
  is_amazon_product: false,
  asin: null,
  other_restrictions: "",
};

const withAddProductDefaults = (initialValues = {}) => ({
  ...addProductDefaultValues,
  ...initialValues,
  is_taxable:
    initialValues.is_taxable === undefined || initialValues.is_taxable === null
      ? addProductDefaultValues.is_taxable
      : initialValues.is_taxable,
  tax_rate:
    initialValues.tax_rate === undefined
      ? addProductDefaultValues.tax_rate
      : initialValues.tax_rate,
  is_amazon_product:
    initialValues.is_amazon_product === undefined ||
    initialValues.is_amazon_product === null
      ? addProductDefaultValues.is_amazon_product
      : initialValues.is_amazon_product,
  asin:
    initialValues.asin === undefined
      ? addProductDefaultValues.asin
      : initialValues.asin,
});

const AddProduct = (props) => {
  const [suppliers, setSuppliers] = useState([]); // state variable in suppliers
  const [uploadButton, setUploadButton] = useState(false); // reset On change handler
  const [files, setFiles] = useState([]); // state variable in files
  const [filesData, setFilesData] = useState([]); // state variable in copy of files Data
  const [isLoding, setIsLoding] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [subCategories, setSubCategories] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState([]);
  const [specification, setSpecification] = useState("");
  const [addSupplier, setAddSupplier] = useState(false);
  const [addInitialValuesData, setAddInitialValuesData] = useState({
    name: "",
    email: "",
    phone: "",
    primary_contact_name: "",
    street: "",
    city: "",
    state: "",
    country: "",
    zip_code: "",
    is_taxable: false,
    tax_rate: null,
    is_amazon_product: false,
    asin: null,
  });

  const [documentFile, setDocumentFile] = useState([]); // state variable in document File
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [selectDisabled, setSelectDisabled] = useState(false);
  const [subCategoryEnabled, setSubCategoryEnabled] = useState(false);
  const [categoryOption, setcategoryOption] = useState([]);
  const [asinValidationTimeout, setAsinValidationTimeout] = useState(null);
  const [isAsinLoading, setIsAsinLoading] = useState(false);
  const [asinValidationMessage, setAsinValidationMessage] = useState("");
  const sunEditorRef = useRef(null);
  const [editorLoaded, setEditorLoaded] = useState(false);
  const [amazonImages, setAmazonImages] = useState([]);

  // Upload multiple image than convert to base 64 and store the data in the state
  const readURI = (e, setFieldValue) => {
    // setUploadButton(true);

    if (e.target.files) {
      /* Get files in array form */
      const getFiles = Array.from(e.target.files);

      let valid = false;
      for (var j = 0; j < getFiles.length; j++) {
        var sCurExtension = getFiles[j];

        const checkFileTyype = sCurExtension.name.match(/\.[0-9a-z]+$/i)[0];

        if (
          checkFileTyype == ".jpeg" ||
          checkFileTyype == ".jpg" ||
          checkFileTyype == ".png"
        ) {
          valid = true;
        } else {
          valid = false;
          break;
        }
      }
      if (!valid) {
        toast.error("File type not supported", {
          autoClose: 3000,
          hideProgressBar: true,
        });
      } else {
        /* Map each file to a promise that resolves to an array of image URI's */
        Promise.all(
          getFiles.map((file, index) => {
            return new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.addEventListener("load", (ev) => {
                resolve({
                  path: ev.target.result,
                  mime_type: file.type,
                  isAmazonImage: false,
                  fileName: file.name
                });
              });
              reader.addEventListener("error", reject);
              reader.readAsDataURL(file);
            });
          })
        ).then(
          (images) => {
            /* Once all promises are resolved, update state with image URI array */

            const mergeFiles = files.concat(images);
            setFiles(mergeFiles);
            setFilesData(mergeFiles);
            setFieldValue("images", mergeFiles);
            // setUploadButton(false);
            e.target.value = "";
          },
          (error) => {
            console.error(error);
          }
        );
      }
      return false;
    } else {
      console.log("Hi Else");
    }
  };

  // Upload pdf file than convert to base 64 and store the data in the state
  const readPDF = (e, setFieldValue) => {
    if (e.target.files) {
      /* Get files in array form */
      const getFiles = Array.from(e.target.files);
      let valid = false;
      var sCurExtension = getFiles[0];

      const checkFileTyype = sCurExtension.name.match(/\.[0-9a-z]+$/i)[0];

      if (checkFileTyype == ".pdf") {
        valid = true;
      } else {
        valid = false;
      }

      if (!valid) {
        toast.error("File type not supported", {
          autoClose: 3000,
          hideProgressBar: true,
        });
      } else {
        /* Map each file to a promise that resolves to an array of image URI's */
        Promise.all(
          getFiles.map((file, index) => {
            return new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.addEventListener("load", (ev) => {
                resolve({
                  path: ev.target.result,
                  mime_type: file.type,
                  name: file.name,
                });
              });
              reader.addEventListener("error", reject);
              reader.readAsDataURL(file);
            });
          })
        ).then(
          (pdf) => {
            /* Once all promises are resolved, update state with PDF URI array */

            setDocumentFile(pdf);
            setFieldValue("upload_doc", pdf);
          },
          (error) => {
            console.error(error);
          }
        );
      }
    }
  };

  // Delete Images after uploading
  const handleDeleteImage = (e, index, setFieldValue) => {
    const copyFiles = [...files];
    const deletedImage = copyFiles[index];
    
    // If it's an Amazon image, remove it from amazonImages state as well
    if (deletedImage.isAmazonImage) {
      // Find the Amazon image in amazonImages array by matching the path
      const updatedAmazonImages = amazonImages.filter(img => img.path !== deletedImage.path);
      setAmazonImages(updatedAmazonImages);
    }
    
    copyFiles.splice(index, 1);
    setFiles(copyFiles);
    setFilesData(copyFiles); // Update filesData as well
    setFieldValue("images", copyFiles);
  };

  // Add product
  const addProduct = async (data) => {
    setIsLoding(true);
    createProduct(data)
      .then((res) => {
        if (res.status === 200) {
          // return;
          const getLenght = res.data.imageUploadUrl.length;
          
          // Separate Amazon images and user images
          const userImages = filesData.filter(img => !img.isAmazonImage);
          const amazonImages = filesData.filter(img => img.isAmazonImage);
          
          // Upload images to S3 in the exact order they appear in the UI
          filesData.forEach((imageData, index) => {
            if (imageData.isAmazonImage) {
              // For Amazon images, download first then upload to S3
              downloadAmazonImage(imageData.path)
                .then((blob) => {
                  // Upload to S3
                  return fetch(res.data.imageUploadUrl[index].uploadURL, {
                    method: "PUT",
                    body: blob,
                  });
                })
                .then(function () {
                  console.log("Amazon image uploaded successfully");
                  if (index === getLenght - 1) {
                    // last one Last index getting and apply logic here
                    setIsLoding(false);
                    props.history.push(
                      `/app/products/view-product/${res.data.product_id}`
                    );
                    toast.success("Product Added Successfully", {
                      autoClose: 3000,
                      hideProgressBar: true,
                    });
                  }
                })
                .catch(function (error) {
                  console.log("Amazon image upload error:", error);
                  if (index === getLenght - 1) {
                    setIsLoding(false);
                    props.history.push(
                      `/app/products/view-product/${res.data.product_id}`
                    );
                    toast.success("Product Added Successfully", {
                      autoClose: 3000,
                      hideProgressBar: true,
                    });
                  }
                });
            } else {
              // For user images, upload base64 data directly
              const contentType = imageData.mime_type;
              const b64Data = imageData.path;
              const replaceDataImage = b64Data.replace(
                /^data:image\/[a-z]+;base64,/,
                ""
              );

              const blob = b64toBlob(replaceDataImage, contentType);
              console.log("blobdata", blob);
              fetch(res.data.imageUploadUrl[index].uploadURL, {
                method: "PUT",
                body: blob,
              })
                .then(function () {
                  console.log("User image uploaded successfully");
                  if (index === getLenght - 1) {
                    // last one Last index getting and apply logic here
                    setIsLoding(false);
                    props.history.push(
                      `/app/products/view-product/${res.data.product_id}`
                    );
                    toast.success("Product Added Successfully", {
                      autoClose: 3000,
                      hideProgressBar: true,
                    });
                  }
                })
                .catch(function (error) {
                  console.log("error", error);
                  if (index === getLenght - 1) {
                    setIsLoding(false);
                    props.history.push(
                      `/app/products/view-product/${res.data.product_id}`
                    );
                    toast.success("Product Added Successfully", {
                      autoClose: 3000,
                      hideProgressBar: true,
                    });
                  }
                });
            }
          });
          
          // Handle document uploads
          res.data.documentUploadUrl.map((url, index) => {
            const getData = documentFile[index];

            const contentType = getData.mime_type;
            const b64Data = getData.path;
            const replaceDataImage = b64Data.replace(
              /^data:application\/[a-z]+;base64,/,
              ""
            );

            const blob = b64toBlob(replaceDataImage, contentType);

            fetch(url.uploadURL, {
              method: "PUT",
              body: blob,
            })
              .then(function () {
                console.log("PDF upload ok done");
              })
              .catch(function (error) {
                console.log("error", error);
              });
          });
        }
      })
      .catch((error) => {
        console.log("error", error);
        if (error.data !== undefined) {
          setIsLoding(false);
          toast.error(error.data.message, {
            autoClose: 3000,
            hideProgressBar: true,
          });
        }
      });
  };

  // Convert base 64 to blob data
  const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  // Download Amazon image and convert to blob
  const downloadAmazonImage = async (imageUrl) => {
    try {
      const response = await fetch(imageUrl);
      if (!response.ok) {
        throw new Error(`Failed to download image: ${response.statusText}`);
      }
      return await response.blob();
    } catch (error) {
      console.error("Error downloading Amazon image:", error);
      throw error;
    }
  };

  /*
   * Function handleCategoryChange get the value for selectedCategory
   */
  const handleCategoryChange = (selectedCategory, setFieldValue) => {
    setSelectDisabled(true);
    setFieldValue("sub_category", "");
    setSelectedSubCategory("");
    setSelectedCategory(selectedCategory);
    getSubCategoryDetail(selectedCategory.value)
      .then((res) => {
        if (res.status === 200) {
          let options = res.data.map(function (cat) {
            return { value: cat.id, label: cat.category };
          });
          setSubCategories(options);
          setSelectDisabled(false);

          options.length > 0
            ? setSubCategoryEnabled(true)
            : setSubCategoryEnabled(false);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setSelectDisabled(false);
      });

    setFieldValue("category", selectedCategory.value);
  };

  /*
   * Function handleSubCategoryChange get the value for selectedSubCategory
   */

  const handleSubCategoryChange = (selectedSubCategory, setFieldValue) => {
    setSelectedSubCategory(selectedSubCategory);
    setFieldValue("sub_category", selectedSubCategory.value);
  };

  /*
   * Function handleSuppliersChange get the value for selectedSupplier
   */

  const handleSuppliersChange = (selectedSupplier, setFieldValue) => {
    setSelectedSupplier(selectedSupplier);
    setFieldValue("suppliers", selectedSupplier);
  };

  const onEditorDescriptionChange = (content, setFieldValue) => {
    console.log("content", content);
    setSpecification(content);
  };

  // Validate ASIN and fetch Amazon product data
  const validateASIN = (asin, setFieldValue) => {
    if (!asin || asin.trim() === "") {
      setAsinValidationMessage("");
      return;
    }

    setIsAsinLoading(true);
    setAsinValidationMessage("");

    fetchAmazonProductByASIN(asin.trim())
      .then((res) => {
        console.log("amazonData", res);
        if (res && res.length > 0) {
          // Auto-fill form fields with Amazon data
          const amazonData = res[0];
          
          if (amazonData.title) {
            setFieldValue("product_name", amazonData.title);
          }
          if (amazonData.description) {
            setFieldValue("description", amazonData.description);
          }
          if (amazonData.manufacturer) {
            setFieldValue("manufacturer", amazonData.manufacturer);
          }
          
          if (amazonData.price) {
            setFieldValue("price", amazonData.price);
          } else {
            toast.error("Price not available for this product", {
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
          if (amazonData.upc) {
            setFieldValue("upc", amazonData.upc);
          }

          if(amazonData.specifications){
            const specsHtml = createAmazonSpecificationHtml(
              amazonData.specifications
            );
            setFieldValue("specification", specsHtml);
            setSpecification(specsHtml);
          }

          // Handle Amazon images
          if (amazonData.images && amazonData.images.length > 0) {
            const amazonImageData = amazonData.images.map((img, index) => ({
              path: img.large || img.medium || img.original,
              mime_type: 'image/jpeg',
              isAmazonImage: true,
              amazonIndex: index,
              originalUrl: img.original // Keep original URL for reference
            }));
            setAmazonImages(amazonImageData);
            
            // Merge with existing uploaded images
            const allImages = [...amazonImageData, ...files];
            setFiles(allImages);
            setFilesData(allImages);
            setFieldValue("images", allImages);
            
            toast.success(`Loaded ${amazonData.images.length} Amazon images`, {
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
          
          toast.success("Amazon product data loaded successfully", {
            autoClose: 3000,
            hideProgressBar: true,
          });
        } else {
          setAsinValidationMessage("The ASIN entered might not be correct");
        }
        setIsAsinLoading(false);
      })
      .catch((error) => {
        console.log("ASIN validation error:", error);
        setAsinValidationMessage("The ASIN entered might not be correct");
        setIsAsinLoading(false);
      });
  };

  // Debounced ASIN validation
  const handleASINChange = (e, setFieldValue) => {
    const asin = e.target.value;
    setFieldValue("asin", asin);
    
    // Clear previous timeout
    if (asinValidationTimeout) {
      clearTimeout(asinValidationTimeout);
    }
    
    // Clear validation message when user starts typing
    setAsinValidationMessage("");
    
    // Set new timeout for 1 second delay
    const timeout = setTimeout(() => {
      if (asin && asin.trim() !== "") {
        validateASIN(asin, setFieldValue);
      }
    }, 1000);
    
    setAsinValidationTimeout(timeout);
  };

  /**
   * This function Add New Suppliers
   * @param  {newSupplierData} newSupplierData data Object
   */

  const addNewSupplierhandler = (newSupplierData) => {
    setIsLoadingButton(true);
    addNewSupplier(newSupplierData)
      .then((response) => {
        if (response.status === 200) {
          getAllSuppliers();
          setAddSupplier(false);
          setIsLoadingButton(false);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  /*
   * Function getAllSuppliers get all the data for Suppliers
   */
  const getAllSuppliers = () => {
    // return;
    setIsLoadingButton(true);
    supplierList()
      .then((res) => {
        if (res.status === 200) {
          // this.setState({
          //   suppliers: res.data,
          // });
          let options = res.data.map(function (cat) {
            return { value: cat.id, label: cat.company_name };
          });
          setSuppliers(options);
          // setSelectedSupplier(options[0]);
          toast.success(res.data.message, {
            autoClose: 3000,
            hideProgressBar: true,
          });
          setIsLoadingButton(false);
        }
      })
      .catch((error) => {
        console.log("error", error);
        toast.error(error.data.message, {
          autoClose: 3000,
          hideProgressBar: true,
        });
        setIsLoadingButton(false);
      });
  };

  const getAllCategory = () => {
    categoryList()
      .then((res) => {
        if (res.status === 200) {
          // this.setState({
          //   categories: res.data,
          // });
          let options = res.data.map(function (cat) {
            return { value: cat.category_id, label: cat.category_name };
          });
          setcategoryOption(options);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  useEffect(() => {
    getAllSuppliers();
    getAllCategory();
  }, []);

  // Cleanup timeout on component unmount
  useEffect(() => {
    return () => {
      if (asinValidationTimeout) {
        clearTimeout(asinValidationTimeout);
      }
    };
  }, [asinValidationTimeout]);

  useEffect(() => {
    console.log("specification in useEffect", specification);
  }, [specification]);

  // Update SunEditor content when specification changes and editor is loaded
  useEffect(() => {
    if (editorLoaded && sunEditorRef.current && specification) {
      try {
        console.log("Updating SunEditor with:", specification);
        // Try different methods to update content
        if (sunEditorRef.current.setContents) {
          sunEditorRef.current.setContents(specification);
        } else if (sunEditorRef.current.setOptions) {
          sunEditorRef.current.setOptions({ content: specification });
        } else if (sunEditorRef.current.core) {
          sunEditorRef.current.core.setContents(specification);
        }
      } catch (error) {
        console.log("Error updating SunEditor content:", error);
      }
    }
  }, [specification, editorLoaded]);

  const productInitialValues = withAddProductDefaults(
    props.location && props.location.state
      ? props.location.state.initialValues
      : {}
  );

  return (
    <>
      <Breadcrumbs
        title="Add Products"
        parent="Product"
        subtitle="Product Admin Panel"
      />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader>
                <h5>Add Product</h5>
              </CardHeader>
              <CardBody>
                <Formik
                  enableReinitialize
                  initialValues={productInitialValues}
                  onSubmit={(values, actions) => {
                    let newValues = values;
                    values.product_name = values.product_name.trim();
                    values.specification =
                      sanitizeProductSpecification(specification);
                    const imagesArray = files.map(function (x) {
                      return {
                        mime_type: x.mime_type,
                      };
                    });
                    values.images = imagesArray;
                    const uploadDocumentArray = values.upload_doc.map(function (
                      x
                    ) {
                      return {
                        mime_type: x.mime_type,
                      };
                    });
                    values.upload_doc = uploadDocumentArray;

                    values = trimObj(values);
                    values.expiration_date = newValues.expiration_date;
                    console.log("values", values);
                    //return;
                    addProduct(values, actions);
                  }}
                  validationSchema={Yup.object().shape({
                    images: Yup.mixed()
                      .required("A file is required")
                      .test("fileFormat", "Image is required", (value) => {
                        return (
                          value &&
                          ["image/png", "image/jpg", "image/jpeg"].includes(
                            value[0]?.mime_type
                          )
                        );
                      }),
                    product_name: Yup.string().required(
                      "Please enter product name"
                    ),
                    weight: Yup.number().typeError("Must be a number"),
                    unit: Yup.string().optional(),
                    manufacturer: Yup.string().required(
                      "Please enter manufacturer"
                    ),
                    description: Yup.string().required(
                      "Please enter description"
                    ),
                    category: Yup.string().required("Please select category"),
                    suppliers: Yup.array().min(1, "Please select suppliers"),
                    price: Yup.number()
                      .typeError("Must be a number")
                      .required("Please enter price")
                      .test(
                        "maxDigitsAfterDecimal",
                        "Price must have 2 digits after decimal or less",
                        (number) => /^\d+(\.\d{1,2})?$/.test(number)
                      ),
                    lot_size: Yup.string().optional(),
                    expiration_date: Yup.date()
                      .required("Please select Expiration Date")
                      .nullable(),
                    minimum_quantity: Yup.number()
                      .typeError("Must be a number")
                      .required("Please enter minimum quantity"),
                    maximum_quantity: Yup.number()
                      .typeError("Must be a number")
                      .required("Please enter maximum quantity"),
                    is_taxable: Yup.boolean(),
                    tax_rate: Yup.number()
                      .when('is_taxable', {
                        is: true,
                        then: Yup.number()
                          .required("Please enter tax rate")
                          .typeError("Please enter tax rate"),
                        otherwise: Yup.number().nullable()
                      }),
                    is_amazon_product: Yup.boolean(),
                    asin: Yup.string()
                      .when('is_amazon_product', {
                        is: true,
                        then: Yup.string()
                          .required("Please enter ASIN"),
                        otherwise: Yup.string().nullable()
                      }),
                  })}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    resetForm,
                    setFieldValue,
                  }) => (
                    <>
                      {console.log("Values handle Change", values)}
                      {console.log("Errors", errors)}
                      {console.log("Touched", touched)}
                      <form
                        className="add-product-form"
                        onSubmit={handleSubmit}
                      >
                        <Row className="product-adding">
                          <Col xl="5">
                            <div className="form-group">
                              {!uploadButton && (
                                <>
                                  <input
                                    className="show-for-sr"
                                    type="file"
                                    name="images[]"
                                    multiple
                                    accept="image/png, image/jpg, image/jpeg"
                                    onChange={(e) => readURI(e, setFieldValue)}
                                    id="file"
                                  />
                                  <label htmlFor="file">
                                    <i className="fa fa-plus"></i> Upload Photo
                                  </label>
                                  <div className="image-limit-info">
                                    <small className="text-muted">
                                      Amazon images: {amazonImages.length} | 
                                      User images: {files.filter(img => !img.isAmazonImage).length} | 
                                      Total: {files.length}
                                    </small>
                                  </div>
                                </>
                              )}
                              <label className="err-msg">
                                {errors.images &&
                                  touched.images &&
                                  errors.images}
                              </label>
                              <ul className="photo-container">
                                {files.map((imageURI, index) => {
                                  return (
                                    <li key={index} className={imageURI.isAmazonImage ? 'amazon-image' : 'user-image'}>
                                      <img
                                        className="photo-uploaded"
                                        src={imageURI.path}
                                        alt={imageURI.isAmazonImage ? "Amazon product image" : "Photo uploaded"}
                                      />
                                      {imageURI.isAmazonImage && (
                                        <div className="amazon-image-badge">
                                          <i className="fa fa-amazon"></i>
                                        </div>
                                      )}
                                      <span
                                        onClick={(e) =>
                                          handleDeleteImage(
                                            e,
                                            index,
                                            setFieldValue
                                          )
                                        }
                                      >
                                        <i className="fa fa-times"></i>
                                      </span>
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          </Col>
                          <Col xl="7">
                            <div className="form form-label-center">
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-4 mb-0">
                                  Amazon Product
                                </Label>
                                <div className="col-xl-9 col-sm-8">
                                  <div className="display-flex">
                                    <div className="checkbox-size">
                                      <Input
                                        className="align-checkbox"
                                        name="is_amazon_product"
                                        type="checkbox"
                                        checked={!!values.is_amazon_product}
                                        onChange={(e)=>{
                                          setFieldValue("is_amazon_product", e.target.checked)
                                        }}
                                        onBlur={handleBlur}
                                      />
                                    </div>
                                    <div className="width-100">
                                      <Input
                                        className="testing"
                                        name="asin"
                                        type="text"
                                        placeholder="ASIN"
                                        value={values.asin || ''}
                                        onChange={(e) => handleASINChange(e, setFieldValue)}
                                        onBlur={handleBlur}
                                        disabled={!values.is_amazon_product}
                                      />
                                      {isAsinLoading && (
                                        <div className="mt-1">
                                          <Spinner size="sm" /> Validating ASIN...
                                        </div>
                                      )}
                                      {asinValidationMessage && (
                                        <label className="err-msg">
                                          {asinValidationMessage}
                                        </label>
                                      )}
                                      <label className="err-msg">
                                        {errors.asin && touched.asin && errors.asin}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </FormGroup>
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-4 mb-0">
                                  Product Name
                                </Label>
                                <div className="col-xl-9 col-sm-8">
                                  <Input
                                    className="form-control"
                                    name="product_name"
                                    type="text"
                                    placeholder="Enter Product Name"
                                    value={values.product_name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                  <label className="err-msg">
                                    {errors.product_name &&
                                      touched.product_name &&
                                      errors.product_name}
                                  </label>
                                </div>
                              </FormGroup>
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-4 mb-0">
                                  UPC
                                </Label>
                                <div className="col-xl-9 col-sm-8">
                                  <Input
                                    className="form-control"
                                    name="upc"
                                    type="text"
                                    placeholder="Code Number"
                                    value={values.upc}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                  <label className="err-msg">
                                    {errors.upc && touched.upc && errors.upc}
                                  </label>
                                </div>
                              </FormGroup>
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-4 mb-0">
                                  Details Per Unit
                                </Label>
                                <div className="col-xl-9 col-sm-8">
                                  <Input
                                    className="form-control"
                                    name="unit"
                                    type="text"
                                    placeholder="Enter Unit"
                                    value={values.unit}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                  <label className="err-msg">
                                    {errors.unit && touched.unit && errors.unit}
                                  </label>
                                </div>
                              </FormGroup>
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-4 mb-0">
                                  Weight
                                </Label>
                                <div className="col-xl-9 col-sm-8">
                                  <Input
                                    className="form-control"
                                    name="weight"
                                    type="text"
                                    placeholder="Weight in Pound"
                                    value={values.weight}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                  <label className="err-msg">
                                    {errors.weight &&
                                      touched.weight &&
                                      errors.weight}
                                  </label>
                                </div>
                              </FormGroup>
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-4 mb-0">
                                  Manufacturer
                                </Label>
                                <div className="col-xl-9 col-sm-8">
                                  <Input
                                    className="form-control"
                                    name="manufacturer"
                                    type="text"
                                    placeholder="Manufacturer Name"
                                    value={values.manufacturer}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                  <label className="err-msg">
                                    {errors.manufacturer &&
                                      touched.manufacturer &&
                                      errors.manufacturer}
                                  </label>
                                </div>
                              </FormGroup>
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-4 mb-0">
                                  Description
                                </Label>
                                <div className="col-xl-9 col-sm-8">
                                  <textarea
                                    className="form-control"
                                    name="description"
                                    placeholder="Enter Description here"
                                    value={values.description}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                  <label className="err-msg">
                                    {errors.description &&
                                      touched.description &&
                                      errors.description}
                                  </label>
                                </div>
                              </FormGroup>
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-4 mb-0">
                                  Select Category
                                </Label>
                                <div className="col-xl-9 col-sm-8">
                                  <Select
                                    name="category"
                                    className="zIndexIncrease "
                                    classNamePrefix="children"
                                    value={selectedCategory}
                                    // onChange={handleChange}
                                    onChange={(selectedOption) => {
                                      handleCategoryChange(
                                        selectedOption,
                                        setFieldValue
                                      );
                                    }}
                                    onBlur={handleBlur}
                                    options={categoryOption}
                                    placeholder="Select Category"
                                  />
                                  <label className="err-msg">
                                    {errors.category &&
                                      touched.category &&
                                      errors.category}
                                  </label>
                                </div>
                              </FormGroup>
                              {subCategoryEnabled ? (
                                <FormGroup className="form-group mb-3 row">
                                  <Label className="col-xl-3 col-sm-4 mb-0">
                                    Select Sub Category
                                  </Label>
                                  <div className="col-xl-9 col-sm-8">
                                    {selectDisabled ? (
                                      <div className="custom-loader select_loader">
                                        <Spinner animation="border" />
                                      </div>
                                    ) : null}
                                    <Select
                                      name="sub_category"
                                      className={`zIndexIncrease ${selectDisabled
                                        ? "disabled_true"
                                        : "disabled_false"
                                        }`}
                                      classNamePrefix="children"
                                      value={selectedSubCategory}
                                      onChange={(selectedOption) => {
                                        handleSubCategoryChange(
                                          selectedOption,
                                          setFieldValue
                                        );
                                      }}
                                      onBlur={handleBlur}
                                      options={subCategories}
                                      placeholder="Select Sub Category"
                                    />
                                  </div>
                                </FormGroup>
                              ) : null}
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-4 mb-0">
                                  Select Supplier
                                </Label>
                                <div className="col-xl-9 col-sm-8">
                                  <Select
                                    name="suppliers"
                                    className="zIndexIncrease suppliers_dropdown"
                                    classNamePrefix="children"
                                    value={selectedSupplier}
                                    onChange={(selectedOption) => {
                                      handleSuppliersChange(
                                        selectedOption,
                                        setFieldValue
                                      );
                                    }}
                                    isMulti
                                    closeMenuOnSelect={false}
                                    onBlur={handleBlur}
                                    options={suppliers}
                                    placeholder="Select Supplier"
                                  />
                                  <span
                                    className="addSupplier"
                                    onClick={() => setAddSupplier(true)}
                                  >
                                    <i className="fa fa-plus"></i>
                                  </span>
                                  <label className="err-msg">
                                    {errors.suppliers &&
                                      touched.suppliers &&
                                      errors.suppliers}
                                  </label>
                                </div>
                              </FormGroup>
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-4 mb-0">
                                  Product Specification
                                </Label>
                                <div className="col-xl-9 col-sm-8">
                                  <div className="clearfix cu_suneditor">
                                    <SunEditor
                                      key={`spec-${specification ? specification.length : 0}`}
                                      defaultValue={specification}
                                      name="specification"
                                      placeholder="Please type here..."
                                      height="150px"
                                      setOptions={{
                                        plugins: [list],
                                        height: 150,
                                        buttonList: [
                                          ["bold", "underline", "italic"],
                                          // "/", // Line break
                                          ["align", "list", "lineHeight"],
                                          ["formatBlock"],
                                        ],
                                      }}
                                      onLoad={(sunEditor) => {
                                        sunEditorRef.current = sunEditor;
                                        setEditorLoaded(true);
                                        console.log("SunEditor loaded, available methods:", Object.getOwnPropertyNames(sunEditor));
                                        console.log("SunEditor prototype methods:", Object.getOwnPropertyNames(Object.getPrototypeOf(sunEditor)));
                                      }}
                                      onChange={(data) =>
                                        onEditorDescriptionChange(
                                          data,
                                          setFieldValue
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-4 mb-0">
                                  Price
                                </Label>
                                <div className="col-xl-9 col-sm-8">
                                  <Input
                                    className="form-control"
                                    name="price"
                                    type="text"
                                    placeholder="Enter Price"
                                    value={values.price}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                  <label className="err-msg">
                                    {errors.price &&
                                      touched.price &&
                                      errors.price}
                                  </label>
                                </div>
                              </FormGroup>

                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-4 mb-0">
                                  Is Taxable
                                </Label>
                                <div className="col-xl-9 col-sm-8 " >

                                  <div className="display-flex">
                                    <div className="checkbox-size">
                                      <Input
                                        className="align-checkbox"
                                        name="is_taxable"
                                        type="checkbox"
                                        // placeholder="Is Taxable"
                                        checked={!!values.is_taxable}
                                        onChange={(e)=>{
                                          setFieldValue("is_taxable", e.target.checked)
                                        }}
                                        onBlur={handleBlur}
                                      />
                                    </div>
                                    <div className="width-100">
                                      <Input
                                        className="testing"
                                        name="tax_rate"
                                        type="number"
                                        placeholder="Tax Rate"
                                        value={values.tax_rate || ''}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        disabled={!values.is_taxable}
                                      />
                                      <label className="err-msg">
                                        {errors.tax_rate && errors.tax_rate}
                                      </label>
                                    </div>
                                  </div>
                                </div>

                              </FormGroup>

                              

                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-4 mb-0">
                                  Lot Size
                                </Label>
                                <div className="col-xl-9 col-sm-8">
                                  <Input
                                    className="form-control"
                                    name="lot_size"
                                    type="text"
                                    placeholder="Enter Lot Size"
                                    value={values.lot_size}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                  <label className="err-msg">
                                    {errors.lot_size &&
                                      touched.lot_size &&
                                      errors.lot_size}
                                  </label>
                                </div>
                              </FormGroup>
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-4 mb-0">
                                  Expiration Date
                                </Label>
                                <div className="col-xl-9 col-sm-8">
                                  <DatePicker
                                    selected={
                                      values.expiration_date
                                        ? new Date(values.expiration_date)
                                        : null
                                    }
                                    onChange={(selectedDate) => {
                                      console.log(selectedDate);
                                      setFieldValue(
                                        "expiration_date",
                                        selectedDate
                                      );
                                    }}
                                    showTimeSelect
                                    minDate={new Date()}
                                    timeInputLabel="Time:"
                                    placeholderText="Expiration Date"
                                    dateFormat="MM/dd/yyyy  h:mm aa"
                                    className="form-control"
                                    name="expiration_date"
                                    timeIntervals={15}
                                  />

                                  <label className="err-msg">
                                    {errors.expiration_date &&
                                      touched.expiration_date &&
                                      errors.expiration_date}
                                  </label>
                                </div>
                              </FormGroup>
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-4 mb-0">
                                  Minimum Quantity
                                </Label>
                                <div className="col-xl-9 col-sm-8">
                                  <Input
                                    className="form-control"
                                    name="minimum_quantity"
                                    type="text"
                                    placeholder="Enter Minimum Quantity"
                                    value={values.minimum_quantity}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                  <label className="err-msg">
                                    {errors.minimum_quantity &&
                                      touched.minimum_quantity &&
                                      errors.minimum_quantity}
                                  </label>
                                </div>
                              </FormGroup>
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-4 mb-0">
                                  Maximum Quantity
                                </Label>
                                <div className="col-xl-9 col-sm-8">
                                  <Input
                                    className="form-control"
                                    name="maximum_quantity"
                                    type="text"
                                    placeholder="Enter Maximum Quantity"
                                    value={values.maximum_quantity}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                  <label className="err-msg">
                                    {errors.maximum_quantity &&
                                      touched.maximum_quantity &&
                                      errors.maximum_quantity}
                                  </label>
                                </div>
                              </FormGroup>
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-4 mb-0">
                                  Other Restrictions
                                </Label>
                                <div className="col-xl-9 col-sm-8">
                                  <textarea
                                    className="form-control"
                                    name="other_restrictions"
                                    placeholder="Enter Other Restrictions here"
                                    value={values.other_restrictions}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                </div>
                              </FormGroup>
                              <FormGroup className="form-group mb-3 row">
                                <Label className="col-xl-3 col-sm-4 mb-0">
                                  Document
                                </Label>
                                <div className="col-xl-5 col-sm-5">
                                  <div className="form-group">
                                    <input
                                      className="show-for-sr"
                                      type="file"
                                      id="upload_doc"
                                      name="upload_doc[]"
                                      accept="application/pdf"
                                      onChange={(e) =>
                                        readPDF(e, setFieldValue)
                                      }
                                    />
                                    <label htmlFor="upload_doc">
                                      <i className="fa fa-plus"></i> Upload
                                      Document
                                    </label>
                                  </div>
                                </div>
                                <div className="col-xl-4 col-sm-4">
                                  <div className="clearfix  show_pdf_name">
                                    {documentFile.map((pdfURI, index) => {
                                      return (
                                        <p
                                          className="truncate"
                                          title={pdfURI.name}
                                        >
                                          {pdfURI.name}
                                        </p>
                                      );
                                    })}
                                  </div>
                                </div>
                              </FormGroup>
                            </div>
                            <div className="offset-xl-3 offset-sm-4">
                              <Button
                                type="submit"
                                color="primary"
                                onClick={handleSubmit}
                                disabled={isLoding}
                              >
                                {isLoding ? "Please Wait..." : "Add"}
                              </Button>
                              <Link to="/app/products">
                                <Button type="button" color="light">
                                  Cancel
                                </Button>
                              </Link>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      {addSupplier && (
        <AddSupplier
          addSupplierModal={addSupplier}
          addNewSupplierhandler={addNewSupplierhandler}
          closeAddSupplierModal={() => setAddSupplier(false)}
          initialValues={addInitialValuesData}
          isLoadingButton={isLoadingButton}
        />
      )}
    </>
  );
};

export default AddProduct;
/* Copyright Information: Created by BuyGroup */
